import { AnyAction } from 'redux';
import { PaginatedResponse } from '@synergy/api';
import { Position } from '@synergy/models';

import {
    POSITIONS_RECEIVED,
    POSITIONS_REQUEST,
    POSITION_CREATE,
    POSITION_CREATED,
    POSITION_DELETE,
    POSITION_FAILED,
    POSITION_UPDATE,
} from './positions-actions';

export interface PositionsReducerState {
    positions: PaginatedResponse<Position>;
    requesting: boolean;
}

export const initialPositionsReducerState: PositionsReducerState = {
    positions: { items: [], limit: 0, page: 0, total: 0 },
    requesting: false,
};

export const positionsReducer = (
    state: PositionsReducerState = initialPositionsReducerState,
    action: AnyAction
): PositionsReducerState => {
    const { type } = action;

    switch (type) {
        case POSITION_CREATE:
        case POSITIONS_REQUEST: {
            return {
                ...state,
                requesting: true,
            };
        }

        case POSITIONS_RECEIVED: {
            return {
                ...state,
                positions: action['positions'],
                requesting: false,
            };
        }

        case POSITION_DELETE: {
            return {
                ...state,
                positions: {
                    ...state.positions,
                    items: state.positions.items.filter((position: Position) => position.id !== action['positionId']),
                    total: state.positions.total - 1,
                },
            };
        }

        case POSITION_UPDATE: {
            return {
                ...state,
                positions: {
                    ...state.positions,
                    items: state.positions.items.map((position: Position) => {
                        if (position.id === action['position'].id) {
                            return action['position'];
                        }
                        return position;
                    }),
                },
            };
        }

        case POSITION_CREATED: {
            return {
                ...state,
                positions: {
                    ...state.positions,
                    items: [action['position'], ...state.positions.items],
                },
                requesting: false,
            };
        }

        case POSITION_FAILED: {
            return {
                ...state,
                requesting: false,
            };
        }

        default: {
            return state;
        }
    }
};
